export default __webpack_public_path__ + "static/media/map-placeholder.0e704164.png";